export default "__VITE_ASSET__BkBApkmu__"